import { Controller } from "@hotwired/stimulus"

// Drag source for a fleet chip that is ALREADY planned on a day cell. Dragging it onto another
// day cell MOVES the fleet allocation there (a different day and/or a different site/task),
// handled by `planning-board-drop`. The equipment analogue of `planning-allocation-drag`.
//
// The payload is marked `kind: "move"` and `resourceType: "Fleet"` so the board-drop controller
// routes it to the fleet move endpoint and can skip a drop back onto the same cell.
export default class extends Controller {
  static values = {
    allocationId: String,
    fleetId: String,
    plannableType: String,
    plannableId: String,
    date: String,
  }

  connect() {
    this.onDragStart = this.handleDragStart.bind(this)
    this.onDragEnd = this.handleDragEnd.bind(this)
    this.element.addEventListener("dragstart", this.onDragStart)
    this.element.addEventListener("dragend", this.onDragEnd)
  }

  disconnect() {
    this.element.removeEventListener("dragstart", this.onDragStart)
    this.element.removeEventListener("dragend", this.onDragEnd)
  }

  handleDragStart(event) {
    event.dataTransfer.effectAllowed = "copyMove"
    event.dataTransfer.setData(
      "application/json",
      JSON.stringify({
        kind: "move",
        allocationId: this.allocationIdValue,
        resourceId: this.fleetIdValue,
        resourceType: "Fleet",
        sourcePlannableType: this.plannableTypeValue,
        sourcePlannableId: this.plannableIdValue,
        sourceDate: this.dateValue,
      }),
    )

    this.element.classList.add("opacity-50", "scale-95")
  }

  handleDragEnd() {
    this.element.classList.remove("opacity-50", "scale-95")
  }
}
